module.exports = __webpack_public_path__ + "static/media/sale-avax.6ebb915c.png";